import { ca } from '@cian/analytics';

import { TActionPlacement, TAnalyticsSiteType } from '../../types/analytics';

export type TSellerType = 'builders' | 'agents';

interface ITrackShowPhone {
  newbuildingId: number;
  url: string;
  sellerType?: TSellerType;
  placement: TActionPlacement;
}

const SHOW_PHONE_ACTIONS: Record<TActionPlacement, string> = {
  gallery: 'Open_compare_jk_gallery',
  infrastructure: 'Open_compare_jk_infrastructure_block',
  table: 'Open_compare_jk_listing',
};

export function trackShowPhone({ newbuildingId, url, sellerType, placement }: ITrackShowPhone) {
  const sellerTypeExtra = sellerType ? { seller_type: sellerType } : {};

  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: SHOW_PHONE_ACTIONS[placement],
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      // Тип сравнения нужен только событию из таблицы — в галерее и на карте его не шлём.
      extra: placement === 'table' ? { compare_type: 'newbuildings', ...sellerTypeExtra } : sellerTypeExtra,
    },
  });
}

interface ITrackOpenContacts {
  newbuildingId: number;
  url: string;
}

type TAiSummaryPhoneCategory = 'Phones' | 'Call';

interface ITrackShowPhoneAiSummary extends ITrackOpenContacts {
  category: TAiSummaryPhoneCategory;
  siteType: TAnalyticsSiteType;
}

export function trackOpenContacts({ newbuildingId, url }: ITrackOpenContacts) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'open_contacts',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
  });
}

export function trackShowPhoneAiSummary({ newbuildingId, url, category, siteType }: ITrackShowPhoneAiSummary) {
  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'Open_compare_jk_ai_summary',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      pageType: 'CompareJKAiSummary',
      siteType,
      extra: { source: 'ListingCompareJK' },
    },
  });
}
